//@ts-expect-error no type definition for baselines
import { airPLSBaseline as baselineFct } from 'baselines';
/**
 * @param data
 */
export function airPLSBaseline(data) {
    data.y = baselineFct(data.y).correctedSpectrum;
    return { data };
}
//# sourceMappingURL=airPLSBaseline.js.map